import React, { createElement, Suspense } from 'react'
import connector from './connector'
import { Props } from './types'
import { getPartnerConfig } from './config'

const Footers: React.FC<Props> = ({ countryCode, cultureCode, partner, screenSize }) => {
  const footerConfig = getPartnerConfig(countryCode, cultureCode, partner, screenSize)

  return (
    <Suspense fallback={null}>
      {createElement(
        // @ts-ignore
        footerConfig.component,
        footerConfig.props
      )}
    </Suspense>
  )
}

export default connector(Footers)
